import { render, staticRenderFns } from "./PromoResolve.vue?vue&type=template&id=e9fcda3e&scoped=true"
import script from "./PromoResolve.vue?vue&type=script&lang=ts"
export * from "./PromoResolve.vue?vue&type=script&lang=ts"
import style0 from "./PromoResolve.vue?vue&type=style&index=0&id=e9fcda3e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fcda3e",
  null
  
)

export default component.exports